// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"TextLoading_loadingWrapper__8YrAa","lottieLoader":"TextLoading_lottieLoader__pMCW8","loadingText":"TextLoading_loadingText__a7OMc"};